<template>
  <div>
    <div style="display: block;margin-top: 90px" >
      <img src="../assets/images/service2.png"  width="100%" />
    </div>
    <section class="service">
      <div class="service-content">
        <el-row>
          <el-col :span= 24>
            <p>最好的健康是</p>
            <h2 style="margin-top: -5px"><span>100%纯天然</span> 服务 </h2>
            <img src = "../assets/images/decor2.png" />
            <p style="text-align: left;font-size: 18px;letter-spacing: 2px">我们知道每个人都需要不同的服务，根据他们的需求和喜好，对我们来说，最重要的是那些来我们中心的人、或购买我们的产品和服务的人、或者只是在我们的社交网络中跟随我们的人的生活质量。我们相信在这里你会找到你一直追求的生活品质。我们非常感谢您选择Centro Bioenergy，迈出这一伟大的一步。无论您选择什么样的服务，我们都会不断联系解决任何问题，我们也将非常感谢您为我们提供反馈，以继续为您提供您应得的最佳质量服务，以及您对我们中心的期望，使其得到满意的执行。</p>
          </el-col>
        </el-row>

      </div>
    </section>
    <section class="service-intro">
      <div class="service-bg">
        <el-row type="flex" align="middle">
          <el-col>
            <div id = "card1" class="card" :class="selected1 == true? 'selected' : ''" @click="handleClick(  $event )">
              <router-link to="/service/s1" style="text-decoration: none">
              <div class="mask">
                <img src="../assets/images/service_1.png">
                <div>
                  <span>综合咨询</span>
                </div>
              </div></router-link>
            </div>
          </el-col>
          <el-col>
            <div id = "card2" class="card"  :class="selected2 == true? 'selected' : ''" @click="handleClick($event)">
              <router-link to="/service/s2" style="text-decoration: none">
              <div class="mask">
                <img src="../assets/images/service_2.png">
                <div>
                  <span>综合营养</span>
                </div>
              </div></router-link>
            </div>
          </el-col>
          <el-col>
            <div class="card">
              <router-link to="/service/s3" style="text-decoration: none">
              <div class="mask">
                <img src="../assets/images/service_3.png">
                <div>
                  <span>糖尿病足</span>
                </div>
              </div>
              </router-link>
            </div>
          </el-col>
          <el-col>
            <div class="card">
              <router-link to="/service/s4" style="text-decoration: none">
              <div class="mask">
                <img src="../assets/images/service_6.png">
                <div>
                  <span>面筋疗法</span>
                </div>
              </div>
              </router-link>
            </div>
          </el-col>
          <el-col>
            <div class="card">
              <router-link to="/service/s5" style="text-decoration: none">
              <div class="mask">
                <img src="../assets/images/service_5.png">
                <div>
                  <span>教育健康</span>
                </div>
              </div>
              </router-link>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <div class="intro-content">
              <!--
              <serslot v-if="s1"><p>结合传统医学和替代医学的手段，即：根据每个人的趋势，安全有效地治愈，减轻或消除症状以及预防疾病。</p>
                <p>中西医结合治疗是一种医学，它考虑了整个人（身体，思想和精神），包括人的所有方面。它强调治疗关系，并利用所有适当的疗法，包括传统疗法和替代疗法。</p>
                <p>美国国立卫生研究院国家补充与替代医学中心定义了中西医结合治疗，并指出：“中西医结合了传统医学疗法和MAC疗法，并有一些科学证据表明其具有最高的质量，安全性和有效性。</p>
              </serslot>
              <serslot v-if="s2"><p>结合传统医学和替代医学的手段，即：根据每个人的趋势，安全有效地治愈，减轻或消除症状以及预防疾病。</p>
                <p>中西医结合治疗是一种医学，它考虑了整个人（身体，思想和精神），包括人的所有方面。它强调治疗关系，并利用所有适当的疗法，包括传统疗法和替代疗法。</p>
                <p>美国国立卫生研究院国家补充与替代医学中心定义了中西医结合治疗，并指出：“中西医结合了传统医学疗法和MAC疗法，并有一些科学证据表明其具有最高的质量，安全性和有效性。</p>
              </serslot>
              -->
              <router-view></router-view>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
import serslot from './service-slot'
export default {
  name: 'service',
  components: {
    serslot
  },
  data () {
    return {
      s1: true,
      s2: false,
      s3: false,
      s4: false,
      selected1: false,
      selected2: false,
      selected3: false,
      selected4: false
    }
  },
  methods: {
    handleClick (obj) {
      console.log(obj.target.parentNode)
      // console.log(obj.path.indexOf('card2'))
      console.log(obj.path[2])
    }
  }
}
</script>

<style scoped>
  .service-content{
    margin: 25px ;
    padding-left:3em;
    padding-right:3em;
    display: block;
    //height: 550px;
    text-align: center;
  }
  .service-content h2 span {
    color: #77b122;
    letter-spacing: 2px;
  }
  .service-bg{
    background: url("../assets/images/cta.jpg");
    display: block;
    width: 100%;
    height: 50em;
  }
  .el-row{
    padding: 2em 8em;
  }
  .card{
    margin: auto;
    padding: auto;
    background-color: cornsilk;
    width: 80%;
  }
  .card img{
    padding-top: 10px;
    width: 8em;
    height: 8em;
  }
  .card span{
    font-size: 25px;
    margin-top: 10px;
    padding-bottom: 20px;
    display: block;
    color:#696969;
  }
  .card:hover .mask{
    z-index: auto;
    display: block;
    background: #0077aa;
    opacity: 0.8;
    width: 100%;
    height: 100%;

    position: relative;
    left: 0px;
    top:0px;

  }
  .intro-content{
    display: block;
    background-color: cornsilk;
    margin-top: -20px;
    padding: 10px;
    width: 100%;
    height: 25em;
    text-align: left;
    padding-top: 10px;
    padding-left: 20px;
    font-size: 18px;
  }
  .selected{
    z-index: auto;
    display: block;
    background: #0077aa;
    opacity: 0.8;
    width: 100%;
    height: 100%;

    position: relative;
    left: 0px;
    top:0px;

  }
</style>



// WEBPACK FOOTER //
// src/components/service.vue